export default __webpack_public_path__ + "files/videos/d862c404d229cb8a3fb251f7901e5c62.mp4";